import React from "react";

import { templates } from "@reactivated";

import { ValuePropsBarBlock } from "../common/ValuePropsBarBlock";

export const Template = (
    props: templates.ValuePropBarBlockTemplate,
): React.JSX.Element | null => {
    if (!props.cms) {
        return null;
    }
    const parsedData = JSON.parse(props.cms);

    return <ValuePropsBarBlock valuePropsData={parsedData} />;
};
